import { render, staticRenderFns } from "./Multistreaming.vue?vue&type=template&id=04912297&scoped=true&"
import script from "./Multistreaming.vue?vue&type=script&lang=js&"
export * from "./Multistreaming.vue?vue&type=script&lang=js&"
import style0 from "./Multistreaming.vue?vue&type=style&index=0&id=04912297&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04912297",
  null
  
)

export default component.exports